import moment from 'moment';
import { getApi } from '../../utils/api';

export interface IWeeklyCounts {
  appointmentCount: number;
  capacityCount: number;
}

export const getWeeklyCounts = (date: Date) =>
  getApi<IWeeklyCounts>(
    `DailyCapacity/weekly?date=${moment(date).format('YYYY-MM-DD')}`
  );
